export default "//file.bilionpass.com/japandx-web/0.0.1/static/bilionpass.afd3ab0b-7132ab.svg";